// Enum with conditions allowed in the rule. Please keep this order for existing CF rules.
export enum ConditionalFormattingConditionType {
    From,
    OnTheToOrCcLine,
    OnTheToLine,
    NotOnTheToLine,
    OnTheCcLine,
    SubjectIncludes,
    SenderAddressIncludes,
    MentionsMe,
    ReadItems,
    UnreadItems,
    WithAttachments,
    WithoutAttachments,
    LowerThanSize,
    GreaterThanSize,
    BetweenSize,
    Categories,
    ImportanceHigh,
    ImportanceNormal,
    ImportanceLow,
    ImportanceCopilotPrioritized,
    FlaggedItems,
    UnflaggedItems,
    MarkedAsCompleted,
    OrganizedBy
}
